import React, { useState } from "react";
import { Inbox } from "lucide-react";
import PostCard from "./PostCard";
import { STATUS } from "./mk";

const FILTERS = ["all", "draft", "approved", "scheduled", "posted", "failed"];

export default function PostsBoard({ posts, onChange, onEdit, liveOff }) {
  const [f, setF] = useState("draft");
  const shown = posts.filter((p) => f === "all" || p.status === f || (f === "scheduled" && p.status === "posting"));
  return (
    <div data-testid="mk-board">
      <div className="flex flex-wrap gap-2 mb-4">
        {FILTERS.map((k) => {
          const n = k === "all" ? posts.length : posts.filter((p) => p.status === k).length;
          return (
            <button key={k} onClick={() => setF(k)} data-testid={`mk-filter-${k}`}
              className={`rounded-full px-3.5 py-1.5 text-sm font-semibold transition-colors ${f === k ? "bg-blue-900 text-white" : "bg-white text-slate-700 ring-1 ring-slate-200 hover:bg-slate-50"}`}>
              {k === "all" ? "All" : STATUS[k].label} <span className="opacity-70">{n}</span>
            </button>
          );
        })}
      </div>
      {shown.length === 0 ? (
        <div className="text-center text-slate-500 py-16 flex flex-col items-center gap-2"><Inbox className="h-10 w-10 text-slate-300" />Nothing here yet.</div>
      ) : (
        <div className="space-y-3">{shown.map((p, i) => <PostCard key={p.id} post={p} i={i} onChange={onChange} onEdit={onEdit} liveOff={liveOff} />)}</div>
      )}
    </div>
  );
}
